import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { observabilityApi, type Alert } from '../../api/observability';

export function AlertManagerPage() {
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const [error, setError] = useState('');

  useEffect(() => {
    void observabilityApi.alerts().then(setAlerts).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/observability" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Operations Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">Alert Manager</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-4 divide-y rounded-lg border dark:border-slate-700">
        {alerts.map((a) => (
          <li key={a.id} className="flex items-center justify-between px-4 py-3 text-sm">
            <div>
              <span className="font-medium">{a.name}</span>
              <span className="ml-2 text-slate-500">{a.type}</span>
            </div>
            <span className={`capitalize ${a.status === 'firing' ? 'text-red-600' : 'text-green-600'}`}>{a.status}</span>
          </li>
        ))}
        {alerts.length === 0 && !error && <li className="px-4 py-6 text-center text-slate-500">No active alerts</li>}
      </ul>
    </div>
  );
}
